import { createStyles, makeStyles } from '@material-ui/core/styles';
export default makeStyles(theme => createStyles({
  textField: {
    margin: `${theme.spacing(0.5)}px 0 ${theme.spacing(3)}px 0`
  },
  postal: {
    display: 'flex'
  },
  addressField: {
    margin: '0'
  },
  field: {
    marginBottom: theme.spacing(3)
  },
  postalCode: {
    width: '135px',
    margin: '0',
    marginRight: theme.spacing(8)
  },
  text: {
    textAlign: 'left'
  },
  icon: {
    marginRight: theme.spacing(1)
  },
  chooseType: {
    '& .MuiSelect-outlined.MuiSelect-outlined': {
      display: 'flex',
      alignItems: 'center'
    }
  }
}));